import { QueryLoadingManager } from '@b-stock/fe-core/bstock-next/components'
import { type OrchestratedCommonListingDetails } from '@b-stock/fe-core/bstock-next/queries'
import { FormattedMessage, interpUri } from '@b-stock/fe-core/bstock-react'

import useAccountId from '@/buyer-portal/helpers/useAccountId'
import buyerOrderByListingIdQuery from '@/buyer-portal/queries/buyerOrderByListingIdQuery'

import { StyledButtonLink } from './styledComponents'

const ns = 'Listing.actionColumn.fulfillmentListing'

export const FixedTermsOrderDetailsButton = ({
  listing,
}: {
  listing: OrchestratedCommonListingDetails
}) => {
  const accountId = useAccountId()

  const orderDetailsResults = buyerOrderByListingIdQuery.useQuery(listing._id)

  return (
    <QueryLoadingManager
      {...orderDetailsResults}
      EmptyComponent={() => null}
      // The loading component causes layout distortion for the other button, resulting in flickering behavior.
      showLoadingComponent={false}
    >
      {({ data: orderDetails }) => (
        <>
          {accountId && orderDetails ? (
            <StyledButtonLink
              href={interpUri`/user/${accountId}/orders/details/${orderDetails._id}`}
            >
              <FormattedMessage id={`${ns}.viewOrder`} />
            </StyledButtonLink>
          ) : null}
        </>
      )}
    </QueryLoadingManager>
  )
}
